export const Tabs = [

    {
        title: 'Latest',
        route: '/news/latest',
    },
    {
        title: 'Community Updates',
        route: '/news/communityUpdates'
    },
    {
        title: 'Product Updates',
        route: '/news/productUpdates'
    },
    {
        title: 'Partnership',
        route: '/news/partnership'
    }
]


